import { render, staticRenderFns } from "./edit-skill.component.html?vue&type=template&id=0110b002&scoped=true&external"
import script from "./edit-skill.component.ts?vue&type=script&lang=ts&external"
export * from "./edit-skill.component.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-skill.component.scss?vue&type=style&index=0&id=0110b002&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110b002",
  null
  
)

export default component.exports